"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfGenerateDescriptionDto = instanceOfGenerateDescriptionDto;
exports.GenerateDescriptionDtoFromJSON = GenerateDescriptionDtoFromJSON;
exports.GenerateDescriptionDtoFromJSONTyped = GenerateDescriptionDtoFromJSONTyped;
exports.GenerateDescriptionDtoToJSON = GenerateDescriptionDtoToJSON;
exports.GenerateDescriptionDtoToJSONTyped = GenerateDescriptionDtoToJSONTyped;
const OrientationOpportunitySessionCreateDto_1 = require("./OrientationOpportunitySessionCreateDto");
const StipendCreateDto_1 = require("./StipendCreateDto");
/**
 * Check if a given object implements the GenerateDescriptionDto interface.
 */
function instanceOfGenerateDescriptionDto(value) {
    return true;
}
function GenerateDescriptionDtoFromJSON(json) {
    return GenerateDescriptionDtoFromJSONTyped(json, false);
}
function GenerateDescriptionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'totalRate': json['totalRate'] == null ? undefined : json['totalRate'],
        'specialtyCode': json['specialtyCode'] == null ? undefined : json['specialtyCode'],
        'pointOfContactName': json['pointOfContactName'] == null ? undefined : json['pointOfContactName'],
        'pointOfContactPhone': json['pointOfContactPhone'] == null ? undefined : json['pointOfContactPhone'],
        'pointOfContactEmail': json['pointOfContactEmail'] == null ? undefined : json['pointOfContactEmail'],
        'orientationSessions': json['orientationSessions'] == null ? undefined : (json['orientationSessions'].map(OrientationOpportunitySessionCreateDto_1.OrientationOpportunitySessionCreateDtoFromJSON)),
        'facilityId': json['facilityId'] == null ? undefined : json['facilityId'],
        'stipends': json['stipends'] == null ? undefined : (json['stipends'].map(StipendCreateDto_1.StipendCreateDtoFromJSON)),
        'engagementType': json['engagementType'] == null ? undefined : json['engagementType'],
        'startTiming': json['startTiming'] == null ? undefined : json['startTiming'],
        'engagementLength': json['engagementLength'] == null ? undefined : json['engagementLength'],
        'shiftTimes': json['shiftTimes'] == null ? undefined : json['shiftTimes'],
        'shiftLengths': json['shiftLengths'] == null ? undefined : json['shiftLengths'],
        'housing': json['housing'] == null ? undefined : json['housing'],
        'meals': json['meals'] == null ? undefined : json['meals'],
        'scrubs': json['scrubs'] == null ? undefined : json['scrubs'],
        'additionalPay': json['additionalPay'] == null ? undefined : json['additionalPay'],
        'emrSystem': json['emrSystem'] == null ? undefined : json['emrSystem'],
        'floating': json['floating'] == null ? undefined : json['floating'],
        'arrivalInstructions': json['arrivalInstructions'] == null ? undefined : json['arrivalInstructions'],
        'additionalNotes': json['additionalNotes'] == null ? undefined : json['additionalNotes'],
    };
}
function GenerateDescriptionDtoToJSON(json) {
    return GenerateDescriptionDtoToJSONTyped(json, false);
}
function GenerateDescriptionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'totalRate': value['totalRate'],
        'specialtyCode': value['specialtyCode'],
        'pointOfContactName': value['pointOfContactName'],
        'pointOfContactPhone': value['pointOfContactPhone'],
        'pointOfContactEmail': value['pointOfContactEmail'],
        'orientationSessions': value['orientationSessions'] == null ? undefined : (value['orientationSessions'].map(OrientationOpportunitySessionCreateDto_1.OrientationOpportunitySessionCreateDtoToJSON)),
        'facilityId': value['facilityId'],
        'stipends': value['stipends'] == null ? undefined : (value['stipends'].map(StipendCreateDto_1.StipendCreateDtoToJSON)),
        'engagementType': value['engagementType'],
        'startTiming': value['startTiming'],
        'engagementLength': value['engagementLength'],
        'shiftTimes': value['shiftTimes'],
        'shiftLengths': value['shiftLengths'],
        'housing': value['housing'],
        'meals': value['meals'],
        'scrubs': value['scrubs'],
        'additionalPay': value['additionalPay'],
        'emrSystem': value['emrSystem'],
        'floating': value['floating'],
        'arrivalInstructions': value['arrivalInstructions'],
        'additionalNotes': value['additionalNotes'],
    };
}
//# sourceMappingURL=GenerateDescriptionDto.js.map